import axios from "axios";

const API = axios.create({
  baseURL: `${process.env.REACT_APP_REST_API_PAYMENTS}`,
});

API.interceptors.request.use((config) => {
  config.headers.Authorization = `Bearer ${process.env.REACT_APP_TOKEN_PAYMENTS}`;
  config.baseURL = `${process.env.REACT_APP_REST_API_PAYMENTS}`;
  return config;
});

API.interceptors.response.use(
  (response) => response,
  (error) => {
    const jcnError = {
      message: error.response?.data?.userMessage || error.response?.data,
    };
    if (jcnError.message === "UNAUTHORIZED") {
      localStorage.clear();
      window.location.replace("/");
    }
    return Promise.reject(jcnError);
  }
);

export default API;
